// extracted by mini-css-extract-plugin
export var dropdownButton = "_3l-0";
export var fullWidthDropdownButton = "_3l-1";
export var icon = "_3l-3";
export var iconPlaceholder = "_3l-2";
export var menuItemRow = "_3l-9";
export var separator = "_3l-e";
export var shortcutContainer = "_3l-7";
export var shortcutContainerFilled = "_3l-8";
export var shortcutIconLg = "_3l-6";
export var shortcutIconMd = "_3l-5";
export var shortcutIconSm = "_3l-4";
export var submenuChevron = "_3l-d";
export var submenuDropdown = "_3l-a";
export var submenuTriggerRow = "_3l-b";
export var submenuTriggerRowOpen = "_3l-c";